import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { BP_DEROGATION_OPTIONS } from '../../../_pewsCalc'

const BpSystolic = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      type="number"
      value={value}
      onChange={onChange}
      label="BP Systolic"
      InputProps={{
        inputProps: { min: 0, max: 400, step: 'any' },
      }}
    />
  </Grid>
)

const BpDiastolic = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      type="number"
      value={value}
      onChange={onChange}
      label="BP Diastolic"
      InputProps={{
        inputProps: { min: 0, max: 400, step: 'any' },
      }}
    />
  </Grid>
)

const BpPosition = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>BP Position</InputLabel>
      <Select value={value} onChange={onChange} label="BP Position">
        <MenuItem value="Sitting">Sitting</MenuItem>
        <MenuItem value="Standing">Standing</MenuItem>
        <MenuItem value="Lying">Lying</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

// PEWS: when no systolic reading exists, the chart's derogation codes let the
// score complete — 'Unsuccessful attempt (concern)' scores 4, the others 0
const BpDerogation = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>BP Not Recorded?</InputLabel>
      <Select value={value} onChange={onChange} label="BP Not Recorded?">
        {BP_DEROGATION_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export { BpSystolic, BpDiastolic, BpPosition, BpDerogation }
